<script setup>
import { useI18n } from '../../i18n'
import { systemRoleName } from '../../access/labels.js'

defineProps({ users: { type: Array, required: true }, selectedId: { type: Number, default: null } })
const emit = defineEmits(['select'])
const { locale, t } = useI18n()

function initials(user) {
  return (user.displayName || user.username).split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase()
}

function dateTime(value) {
  const code = ({ uk: 'uk-UA', ru: 'ru-RU', en: 'en-GB' })[locale.value] ?? 'uk-UA'
  return value ? new Date(value).toLocaleString(code) : t('neverSignedIn')
}
</script>

<template>
  <div class="access-user-table-wrap">
    <table class="access-user-table">
      <thead><tr><th>{{ t('userColumn') }}</th><th>{{ t('role') }}</th><th>{{ t('stationAccess') }}</th><th>{{ t('status') }}</th><th>{{ t('lastSignIn') }}</th></tr></thead>
      <tbody>
        <tr v-for="user in users" :key="user.id" :data-user-id="user.id"
          :class="{ selected: user.id === selectedId }" tabindex="0"
          @click="emit('select', user)" @keydown.enter="emit('select', user)">
          <td><span class="access-avatar">{{ initials(user) }}</span><span><strong>{{ user.displayName }}</strong><small>{{ user.username }}</small></span></td>
          <td><span class="role-chip" :data-role="user.role.systemCode || 'CUSTOM'">{{ systemRoleName(t, user.role) }}</span></td>
          <td>{{ user.stationPolicy === 'ALL' ? t('allStations') : t('stationCount', { count: user.stationCount }) }}</td>
          <td><span class="account-status" :class="user.enabled ? 'enabled' : 'blocked'"><i></i>{{ user.enabled ? t('userActive') : t('userBlocked') }}</span></td>
          <td>{{ dateTime(user.lastLoginAt) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
